import { Path, Svg } from '@react-pdf/renderer';

const PdfSiUsb = () => (
  <Svg width="50" height="50" viewBox="0 0 24 24">
    <Path
      d="M7.75 8.75H16.25V17.25C16.25 18.3546 15.3546 19.25 14.25 19.25H9.75C8.64543 19.25 7.75 18.3546 7.75 17.25V8.75Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <Path d="M14.25 8.5V4.75H9.75V8.5" stroke="currentColor" strokeWidth={2} strokeLinejoin="round" />
  </Svg>
);
export default PdfSiUsb;
